import { useCallback, useContext, useMemo, useState } from 'react';

import { MainContext, useTranslation } from '@ezbobdev/ui-framework';

export const useLanguageSelect = (props) => {
  const { onChange, buttonProps } = props;

  const { actions } = useContext(MainContext);

  const { i18n } = useTranslation();
  const [menuAnchor, setMenuAnchor] = useState(null);
  const isMenuOpen = Boolean(menuAnchor);

  const languageIso639Code = i18n.language;
  const countryAlpha2Code = languageIso639Code.split('-').pop();

  const useIconButtons = actions.settings.getUserConfigProp('widgetsConfig.materialAppBar.useIconButtons');

  const availableLanguages = useMemo(() => {
    const { resources, supportedLngs } = i18n.options;
    const languages = Object.keys(resources).reduce((result, key) => {
      const isSupportedLanguage = supportedLngs?.includes(key);

      if (isSupportedLanguage) {
        const languageData = {
          value: key,
          selected: key === languageIso639Code,
        };

        result.push(languageData);
      }

      return result;
    }, []);

    return languages;
  }, [i18n]);

  const onMenuOpen = useCallback((e) => setMenuAnchor(e.currentTarget), [setMenuAnchor]);
  const onMenuClose = useCallback(() => setMenuAnchor(null), [setMenuAnchor]);

  const onLanguageChange = useCallback(
    async (e) => {
      const { value } = e.target.dataset;

      i18n.changeLanguage(value);
      onMenuClose();

      if (typeof onChange === 'function') {
        await onChange(value);
      }
    },
    [i18n, onMenuClose],
  );

  return {
    useIconButtons,
    languageIso639Code,
    countryAlpha2Code,
    availableLanguages,
    isMenuOpen,
    menuAnchor,
    buttonProps,
    onLanguageChange,
    onMenuClose,
    onMenuOpen,
  };
};
